import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddCircleBlue, CloseButton, CustomDelete, FullTable } from 'components';
import { CustomModal } from 'components/modal/modalBase';
import { eventActions, httpRequestsOnSuccessActions } from 'store';
import { FindSuccessItem, RolePermission, sortListByKey } from 'utils';
import { ACTION_TYPE, DELETE_ACTION_TYPE, eventBody, eventHead, eventNotYet } from './constants';
import { CreateEvent } from './createEvent';

export const Events = ({ model, tableTitle, permissions }) => {
    const dispatch = useDispatch();
    const eventList = useSelector((state) => state.evens.eventList);
    const hasPermission = permissions?.length ? RolePermission(permissions) : true;
    const [filters, setFilters] = useState({});
    const [modal, setModal] = useState(null);
    const deleteSuccess = FindSuccessItem(DELETE_ACTION_TYPE);

    const getEvents = (load) => {
        const params = { ...filters };
        delete params.page;
        delete params.activeTab;
        dispatch(eventActions.getEvents(params, model?.resource, load));
    };

    useEffect(() => {
        getEvents();
    }, [filters]);

    useEffect(() => {
        if (deleteSuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_ACTION_TYPE));
            setModal(null);
            getEvents('noLoad');
        }
    }, [deleteSuccess]);

    const closeModal = () => setModal(null);

    const handleAction = (item, name) => {
        if (!hasPermission) return;
        if (name === 'delete') {
            setModal(
                <CustomDelete
                    text="Are you sure you want to delete this event? This action cannot be undone."
                    info="Delete Event ?"
                    handleDel={() => dispatch(eventActions.deleteEvent(item?.id))}
                    handleClose={closeModal}
                    actionType={DELETE_ACTION_TYPE}
                    noClose
                />
            );
        }
        if (name === 'edit') {
            setModal(<CreateEvent model={model} info={item} handleClose={closeModal} afterSuccess={() => getEvents('noLoad')} />);
        }
    };

    return (
        <>
            {tableTitle && <p className="modal-header-title">{tableTitle}</p>}
            <div className="header-action-btn">
                {hasPermission && (
                    <AddCircleBlue
                        text={'Add Event'}
                        handleClick={() =>
                            setModal(<CreateEvent model={model} handleClose={closeModal} afterSuccess={() => getEvents('noLoad')} />)
                        }
                    />
                )}
            </div>
            <FullTable
                savedParams={filters}
                getParams={(e) => setFilters(e)}
                head={eventHead(hasPermission)}
                body={eventBody(hasPermission)}
                loadingType={ACTION_TYPE}
                list={sortListByKey(eventList?.data, 'fullName', filters)}
                handleClickButton={handleAction}
                notYet={eventNotYet}
                margin={'0'}
            />
            <CustomModal
                openDefault={!!modal}
                handleOpenClose={closeModal}
                content={
                    <div style={{ outline: 'none' }} className="modal-wrapper-style open-sans">
                        <div className="modal-header-style">
                            <CloseButton handleCLic={closeModal} />
                        </div>
                        <div className="modal-body-style-small">{modal}</div>
                    </div>
                }
            />
        </>
    );
};
